<ng-container *ngIf="action$ | async"></ng-container>
<ng-container *ngIf="countertop$ | async"></ng-container>
<ng-container *ngIf="material$ | async"></ng-container>

<div class="flex flex-row space-x-3 items-start">
  <csl-item-card
    [iconLink]="material?.cropTextureLink"
    [disabled]="disabled"
    (selectClicked)="selectMaterial()"
    i18n-title
    title="Материал столешницы"
    [description]="getMaterialName(material) || defaultMaterialDescription">
    <div
      itemCardIcon
      class="colored-icon"
      *ngIf="!material?.textureName && material?.color"
      [ngStyle]="{ 'background-color': '#' + material?.color }"></div>
  </csl-item-card>
</div>
